const Token = require('markdown-it/lib/token');
const escapeHtml = require('stringify-entities').escape;

const variableTextPattern = /.*{{ ([^{}]+?) }}.*/;

const parseMeta = meta => {
  const parseTitle = str => {
    const m = str.match(/key="(.+?)"/);
    if (!m || m.length !== 2) {
      return null;
    }
    return m[1];
  };
  const result = {};
  const sheetKey = parseTitle(meta);
  if (sheetKey) {
    result.sheetKey = sheetKey;
  }
  return result;
};

const openPattern = /^\[custom_calculator.+\]$/;
const endPattern = '[/custom_calculator]';

 /** @param {import('markdown-it')} md */
module.exports = (md) => {
  md.block.ruler.before('paragraph', 'custom_calculator', (state, startLine, endLine) => {
    const firstLine = state.getLines(startLine, startLine + 1, state.blkIndent, false).trim();
    if (!openPattern.test(firstLine)) {
      return false;
    }

    const meta = parseMeta(state.getLines(startLine, startLine + 1, state.blkIndent, false));
    const sheetKey = meta.sheetKey;
    if (!sheetKey) {
      return false;
    }

    let closeFlag = false;
    let closerLine;
    let content = '';
    for (closerLine = startLine + 1; closerLine <= endLine; closerLine++) {
      const closerStart = state.bMarks[closerLine] + state.tShift[closerLine];
      if (state.src.substr(closerStart, endPattern.length) === endPattern) {
        closeFlag = true;
        break;
      }

      content += state.getLines(closerLine, closerLine + 1, state.blkIndent, false) + '\n';
    }

    if (!closeFlag) {
      return false;
    }

    const contentTokens = [];
    state.md.block.parse(content, state.md, state.env, contentTokens);
    const tokensToBePushed = [];
    const variableTexts = [];
    let isValidFormat = true;
    let reservedTokens;
    let reservedIndex;

    for (let index = 0; index < contentTokens.length; index++) {
      const token = contentTokens[index];
      // 予約されたトークンを見出しcloseタグの直後にpushする
      if (token.type === 'heading_close' && index === reservedIndex + 1) {
        tokensToBePushed.push(token);
        tokensToBePushed.push(reservedTokens);
        continue;
      } else if (token.type !== 'inline') {
        tokensToBePushed.push(token);
        continue;
      }

      const m = token.content.match(variableTextPattern);
      if (!m || m.length !== 2) {
        tokensToBePushed.push(token);
        continue;
      }

      const content = m[0].trim();
      const variableText = m[1].trim();
      if (variableTexts.includes(variableText)) {
        isValidFormat = false;
        break;
      }

      variableTexts.push(variableText);
      const descriptorDivToken = new Token('html_inline', '', 0);

      /* このindexでtokensToBePushedにトークンをpushするとmarkdown-it-factory.jsのparse()とぶつかるため、
         同要素のcloseタグの後でトークンをpushできるよう、予約しておく。 */
      if (index > 0 && contentTokens[index - 1].type === 'heading_open') {
        descriptorDivToken.content = `<div class="custom_calculator_variable-${escapeHtml(sheetKey)}" data-type="${escapeHtml(variableText)}" data-text="${escapeHtml(content)}"></div>`;
        reservedTokens = descriptorDivToken;
        reservedIndex = index;
        tokensToBePushed.push(token);
        continue;
      }

      descriptorDivToken.content = `<div class="custom_calculator_variable-${escapeHtml(sheetKey)}" data-type="${escapeHtml(variableText)}" data-text="${escapeHtml(content)}">${content}</div>`;
      tokensToBePushed.push(descriptorDivToken);
    }

    if (!isValidFormat) {
      return false;
    }

    const customCalculatorOpen = state.push('custom_calculator_open', 'template', 1);
    customCalculatorOpen.attrs = [['id', 'kamigame_custom_calculator_template'], ['class', 'kamigame_custom_calculator_template'], ['data-key', escapeHtml(sheetKey)]];
    customCalculatorOpen.block = true;

    tokensToBePushed.forEach(t => state.tokens.push(t));
    const customCalculatorClose = state.push('custom_calculator_close', 'template', -1);
    customCalculatorClose.block = true;

    state.md.helperScripts.add('https://kamigame.jp/vls-kamigame-gametool/js/custom-calculator/app.js');
    state.line = closerLine + 1;
    return true;
  });
};
